import { ConsoleLogger } from '@/lib/logger/console-logger';
import { NetworkLogger } from '@/lib/logger/network-logger';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './index.css';
import './lib/i18n';
import { appFeature } from '@/helpers/feature.ts'; // Import i18n configuration

// Register service worker only for PWA (installed app)
if (window.matchMedia('(display-mode: standalone)').matches) {
  registerSW({ immediate: true });
}

if (import.meta.env.VITE_APP_BROWSER_LOGGER_ENABLED === 'true') {
  const consoleLogger = new ConsoleLogger({
    endpoint: import.meta.env.VITE_APP_BROWSER_LOGGER_PATH,
    batchSize: 10,
    flushInterval: 5000,
    debug: false,
  });

  const networkLogger = new NetworkLogger({
    endpoint: import.meta.env.VITE_APP_BROWSER_LOGGER_PATH,
    batchSize: 10,
    flushInterval: 5000,
    debug: false,
  });

  window.__CONSOLE_LOGGER = consoleLogger;

  if (process.env.NODE_ENV !== 'production') {
    // In development, React 18 strict mode will mount/unmount components twice
    window.__LOGGER_CLEANUP = () => {
      consoleLogger?.cleanup();
      networkLogger?.cleanup();
    };
  }
}

window.__APP_FEATURE = appFeature;

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
